import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dashboard from './dashboard';
import { getProfile,getDashboardCount } from 'services/redux/auth/login/action';
import {
  fetchUnreadNotifications,
  fetchAllNotifications,
} from 'services/redux/sales/appNotifications/action';
import { addInCart } from 'services/redux/brandActivtion/products/action';
import { checkDarwinAttendance } from 'services/redux/darwin/action';
import { selectHasOpenDarwinDuty, selectAttendanceStack } from 'services/attendance/attendanceStatus';

const mapStateToProps = (state) => {
  const userProfileData = state.loginReducer.userProfile;
  let role = [];
  let teamId = [];
  let attCheckIn = [];
  let attCheckInSite = [];
  let departmentId = [];
  let userId = [];
  let userAlerts = [];
  let isApprovalAllowed = [];
  let siteInfoFeature = userProfileData.site_information_feature;
  if (
    userProfileData &&
    userProfileData.teams &&
    userProfileData.teams.length
  ) {
    userProfileData.teams.map((obj) => {
      teamId.push(obj.team_id);
      departmentId.push(obj.department_id);
    });
  }
  if (
    userProfileData &&
    userProfileData.roles &&
    userProfileData.roles.length
  ) {
    userProfileData.roles.map((obj) => role.push(obj.id));
  }
  const attValSource =
    userProfileData?.attVal ||
    userProfileData?.att_val ||
    [];
  if (attValSource.length) {
    attValSource.forEach((obj) => {
      attCheckIn.push(obj.id);
      attCheckInSite.push(obj);
    });
  }
  if (
    userProfileData &&
    userProfileData.id
  ) {
    userId.push(userProfileData.id);
    isApprovalAllowed.push(userProfileData.is_approval_allowed);
  }

  if (
    userProfileData && userProfileData !== undefined &&
    userProfileData.popup_show !== null
  ) {
    userAlerts.push({'popup_show':userProfileData.popup_show, 'popup_data':userProfileData.popup_data});
  }

  return {
    userData: {
      teamId,
      departmentId,
      role,
      siteInfoFeature,
      attCheckIn,
      attCheckInSite,
      userId,
      userAlerts,
      isApprovalAllowed,
      attendanceTabFlag: !!userProfileData?.attendance_tab_flag,
      darwinManagerCheck: !!userProfileData?.darwin_manager_check,
      isJourneyStarted: !!userProfileData?.is_journey_started,
      hasOpenDarwinDuty: selectHasOpenDarwinDuty(state),
      // Today's open duty only — not stale is_darwin_checked_in from prior days
      hasOpenDutyToday: selectAttendanceStack(state).length > 0,
      isDarwinCheckedIn:
        Boolean(state.darwinReducer?.checkDarwinAttendance) ||
        selectHasOpenDarwinDuty(state),
    },
    unreadNotifications: state.toastReducer.unreadNotifications,
    allNotifications: state.toastReducer.allNotifications,
    viewCart: state.productsReducer.viewCart,
    dashboardCount: state.loginReducer.dashboardCount,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProfile,
      fetchUnreadNotifications,
      fetchAllNotifications,
      addInCart,
      getDashboardCount,
      checkDarwinAttendance,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
